export const SIZE_GUIDE_TEXT = 'Size Guide';

export const HOW_TO_MEASURE = 'How to Measure';

export enum UNITS {
  IN = 'in',
  CM = 'cm',
}

export const STICKY_COLUMN_CLASSNAME = 'sticky-column';

export const SOLD_OUT = 'soldOut';

export const SHOW_ANIMATION_KEY = 'SizeGuideShownOnce';
